import { Box, Card, CardContent, Typography } from "@mui/material";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  BarElement,
  Legend,
} from "chart.js";

import { Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  BarElement,
  Legend
);

interface ChartCardProps {
  title: string;
  data: any;
  type: string;
  isBelow800: boolean;
  info: any;
}

const ChartCard = ({ title, data, type, isBelow800, info }: ChartCardProps) => {
  return (
    <Card
      sx={{
        minWidth: 250,
        height: isBelow800 ? "100%" : 500,
        border: "none",
        borderRadius: 4,
        overflow: "hidden",
        position: "relative",
        mt: 2,
        boxShadow: "0 8px 10px #00000040",
        padding: 2,
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {title}
          </Typography>

          <Typography
            variant="body2"
            color="text.primary"
            sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <Tooltip
              title={
                <>
                  <Typography fontSize={16} mb={1}>
                    {info.desc}
                  </Typography>
                  <Typography fontSize={16}>{info.time}</Typography>
                </>
              }
            >
              <InfoOutlined color="action" fontSize="small" />
            </Tooltip>
          </Typography>
        </Box>
        <Box
          mt={3}
          sx={
            isBelow800
              ? undefined
              : { height: "75%", width: "95%", position: "absolute" }
          }
        >
          {type === "Bar" ? (
            <Bar
              data={data}
              options={{
                responsive: true,
                maintainAspectRatio: isBelow800 ? true : false,
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }}
            />
          ) : (
            <Line
              data={data}
              options={{
                responsive: true,

                maintainAspectRatio: isBelow800 ? true : false,

                scales: {
                  y: {
                    ticks: {
                      stepSize: 40,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                elements: {
                  line: {
                    tension: 0.4, // Smooth curve
                  },
                },
              }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChartCard;
